import { HttpClient } from '@angular/common/http';
import { inject, Injectable, signal } from '@angular/core';
import { ApiResponse, APIRouteMap } from '@core/models/api';

import { CultureService, Language } from '@paypoint-frontend/web-core';
import { map, Observable, timer } from 'rxjs';

interface Languages {
  languages: Language[];
}

@Injectable({ providedIn: 'root' })
export class LangService {
  private http = inject(HttpClient);
  private readonly cultureService = inject(CultureService);
  lang = signal(localStorage.getItem('currentLang'));

  getLang() {
    return this.cultureService.currentLang?.code ?? 'ro';
  }

  getLangs(): Observable<Language[]> {
    return this.http
      .get<ApiResponse<Languages>>(APIRouteMap.CONTENT_GETLANGUAGES)
      .pipe(
        map((response) => {
          const output = <Language[]>response.data?.languages;
          output.forEach((item) => {
            item.isDefault = item.code === 'ro' ? true : false;
          });
          return output;
        }),
      );
  }

  isRefreshed = signal<boolean>(true);

  refresh() {
    this.isRefreshed.update((value) => !value);

    timer(500).subscribe(() => {
      this.isRefreshed.update((value) => !value);
    });
  }
}
